import {match} from 'ts-pattern';

import {useEffect} from 'react';

import {chatAgentApi} from '@dms/api/core';

import {onSendEvent, Type} from '@chat/shared/graphql';
import {useTypingState} from '@chat/ui';

import {chatAppSync} from '../utils/chatAppSync';

interface UseChatSubscribeProps {
  conversationId?: string;
  currentUserId?: string;
}

export function useChatSubscribe(props: UseChatSubscribeProps) {
  const {conversationId, currentUserId} = props;

  const [refetchChatHistory] = chatAgentApi.useLazyGetAgentEventsQuery();
  const {isTyping, acknowledgeTyping, resetTypingManual} = useTypingState();

  useEffect(() => {
    if (!conversationId || !currentUserId) {
      return;
    }

    const chatSubscription = chatAppSync
      .graphql({
        query: onSendEvent,
        variables: {conversationId},
      })
      .subscribe({
        next: (event) => {
          if (!event.data) {
            return;
          }

          match(event.data.onSendEvent.type)
            .with(Type.TYPING, () => {
              if (event.data.onSendEvent.userId !== currentUserId) {
                acknowledgeTyping();
              }
            })
            .with(Type.READ, () => refetchChatHistory({conversationId}))
            .otherwise(() => {
              refetchChatHistory({conversationId});
              resetTypingManual();
            });
        },
      });

    return () => {
      chatSubscription.unsubscribe();
    };
  }, [refetchChatHistory, conversationId, acknowledgeTyping, resetTypingManual, currentUserId]);

  return {
    isTyping,
  };
}
